import Plan from 'modules/upsell/lib/selfUpsell/plans/Plan'
import type PlanVariant from 'modules/upsell/lib/selfUpsell/plans/PlanVariant'
import { initF25AddonVariants } from 'modules/upsell/lib/selfUpsell/plans/f25Addon'
import { SelfUpsell } from 'modules/upsell/lib/selfUpsell/types'

export type F25PlanDTO = {
  f25Addons: Plan[]
}

function getF25Plans(rawBundles: SelfUpsell, country: string) {
  const f25AddonVariants = initF25AddonVariants(rawBundles, country)

  return {
    f25Addons: groupVariants(f25AddonVariants),
  }
}

function groupVariants(variants: PlanVariant[]): Plan[] {
  const plans: Record<PlanVariant['title'], Plan> = {}

  variants.forEach((variant) => {
    const plan = plans[variant.title.toLowerCase()]
    if (!plan) {
      plans[variant.title.toLowerCase()] = new Plan(variant)
    } else {
      plan.addVariant(variant)
    }
  })
  return Object.values(plans)
}

export default getF25Plans
